export default __webpack_public_path__ + "img/7b08317889fa8c655e6eb949da143f91.svg";